
export class EInvoiceEmailOcrReprocessDto {
    guids: string[];
}